//@ts-nocheck
import { parseExtractedMarkdown } from './parseExtractedMarkdown';
import {
  Block,
  PartialBlock
} from "@blocknote/core";
// import { ServerBlockNoteEditor } from "@blocknote/server-util";

// console.log("=====ServerBlockNoteEditor ", ServerBlockNoteEditor)

let key = 'authorization';
let endPoint = 'http://localhost:3000';
export let frontEndPoint = 'http://localhost:4200';

const requestHeaders = new Headers();
requestHeaders.append('pragma', 'no-cache');
requestHeaders.append('cache-control', 'no-cache');
requestHeaders.append("Content-Type", "application/json");

let initiativeId: any = '';
let subscriptionId: any = '';
let editorValue: any = {};
let currentController = null;

export function setSubscriptionAndInitiativeId(jsonData: any) {
  initiativeId = jsonData?.initiativeId;
  subscriptionId = jsonData?.subscriptionId;
  const teamId: any = jsonData?.teamId;
  editorValue = jsonData;

  if (jsonData.environmentName === 'dev') {
    key = 'devauthorization';
  }
  if (jsonData.environmentName === 'qa') {
    key = 'qaauthorization';
    endPoint = 'https://qa-api.shorterloop.com';
    frontEndPoint = 'https://qa.prodeasy.com';
  }
  if (jsonData.environmentName === 'staging') {
    key = 'stagingauthorization';
    endPoint = 'https://staging-api.shorterloop.com';
    frontEndPoint = 'https://staging-frontend-main-replicate.web.app';
  }
  if (jsonData.environmentName === 'prod') {
    key = 'prodauthorization';
    endPoint = 'https://api.shorterloop.com';
    frontEndPoint = 'https://app.shorterloop.com';
  }
  const token = getCookie(key);
  if (!token) {
    handleRedirections()
  }

  requestHeaders.set("Authorization", `Bearer ${token}`);
  requestHeaders.set("SubscriptionId", subscriptionId);
  requestHeaders.set("InitiativeId", initiativeId);
  requestHeaders.set("teamId", teamId);
}

export async function uploadFile(file: File) {
  const form = new FormData();
  form.append(file.name, file);
  form.append('artifactId', editorValue?.id);
  form.append('usedAt', 'wiki');
  const initiativeId = editorValue?.initiativeId;

  const meta = {
    'x-amz-meta-artifactType': 'wiki',
    'x-amz-meta-artifactId': String(editorValue?.id),
    'x-amz-meta-addToAIContext': 'true',
  };

  meta['x-amz-meta-artifactLink'] = `/api/users/initiative/${initiativeId}/wiki/${editorValue?.id}`;

  form.append('meta', JSON.stringify(meta));

  const clonedHeaders = new Headers(requestHeaders);

  clonedHeaders.delete("Content-Type");

  const requestOptions = {
    method: 'POST',
    headers: clonedHeaders,
    body: form
  };

  const ret = await fetch(`${endPoint}/api/assets`, requestOptions);
  const data = await ret.json();
  return `${data.url}/${file.name}`;
}

export async function getInitiativeDetails() {
  if (!initiativeId) {
    return true;
  }
  const requestOptions: any = {
    method: 'get',
    headers: requestHeaders
  };
  const response = await fetch(`${endPoint}/api/initiatives/product-user-mapping/${initiativeId}`, requestOptions);
  const { data } = await response.json();
  return data;
};

export async function getArtifactDetails() {
  if (!initiativeId) {
    return true;
  }
  const requestOptions: any = {
    method: 'get',
    headers: requestHeaders
  };
  const response = await fetch(`${endPoint}/api/initiatives/${initiativeId}/artifacts-tree-structure`, requestOptions);
  const { data } = await response.json();
  return data;
};

export function handleRedirections() {
}

export async function sourceContentRequest(assetId, method = 'GET', payload: any = null, suffix = '') {
  const response = await fetch(`${endPoint}/api/v2/documents/${encodeURIComponent(assetId)}/content${suffix}`, {
    method, headers: requestHeaders, ...(payload ? { body: JSON.stringify(payload) } : {})
  });
  const result = await response.json();
  if (!response.ok || !result.success) throw new Error(result.message || 'The document could not be loaded. Please retry.');
  return result.data;
}

export function getRandomColorFromSet() {
  const colors = [
    '#FFB6C1', // Light Pink
    '#87CEFA', // Light Sky Blue
    '#98FB98', // Pale Green
    '#FFD700', // Gold
    '#FF69B4', // Hot Pink
    '#40E0D0', // Turquoise
    '#FF6347', // Tomato
    '#9370DB', // Medium Purple
    '#F5DEB3'  // Wheat
  ];

  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
}
export function getCookie(cookieName: any) {
  const cookie: any = {};
  document.cookie.split(';').forEach(function (el) {
    const [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });

  return cookie[cookieName];
}
function getPageName(jsonArray: any) {
  const heading = jsonArray.find(block => block.type === 'heading');
  if (!heading) return null;
  const plainText = content => typeof content === 'string' ? content :
    (content || []).map(inline => inline.text ?? plainText(inline.content)).join('');
  // Keep the complete heading, including styled spans and link labels. An
  // empty heading during editing should not replace the title with a subheading.
  return plainText(heading.content).trim() || null;
}

export function debounce(func, delay = 500) {
  let timeout = null
  return (...args) => {
    if (timeout) clearTimeout(timeout)

    timeout = setTimeout(() => {
      func(...args)
      timeout = null
    }, delay)
  }
}


/**
 * Saves the provided jsonBlocks and value to storage.
 *
 * @param {Block[]} jsonBlocks - The array of blocks to be saved.
 * @param {any} value - The value object containing additional information.
 * @returns {Promise<any>} A promise that resolves to the saved data.
 */
export const saveToStorage = debounce(async (editor, jsonBlocks, value) => {
  if (currentController) {
    currentController.abort();
  }
  const html = await editor.blocksToHTMLLossy(jsonBlocks);

  const payload: any = {
    body: jsonBlocks,
    html,
    isAssociatedWithWorkItem: value?.isAssociatedWithWorkItem
  };
  const title = getPageName(jsonBlocks);
  if (title && title !== value.title) payload.title = title;

  const requestOptions: any = {
    method: 'PUT',
    headers: requestHeaders,
    body: JSON.stringify(payload),
  };

  const savedPageId = value?.id;
  if (!savedPageId) {
    return false;
  }
  currentController = new AbortController();
  requestOptions.method = 'PUT';
  const pageId = 'page/' + savedPageId;
  requestOptions.signal = currentController.signal;

  try {
    const response = await fetch(`${endPoint}/api/wiki/${pageId}`, requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const { data } = await response.json();
    if (data) {
      // Announce heading-derived title changes without reloading the editor.
      // Routine body saves do not need another metadata notification.
      if (data.alias !== value.alias || data.title !== value.title) {
        value.alias = data.alias;
        value.title = data.title;
        window.parent.postMessage({ type: 'PAGE_ALIAS_UPDATED', ...value }, '*');
      }
    }
    return data;
  }
  catch (error) {
    if (error.name === 'AbortError') {
      console.log('Previous PUT request was cancelled.');
    } else {
      console.error('PUT request error:', error);
    }
  } finally {
    currentController = null;
  }
});

/**
 * Fetches wiki data based on the provided jsonData and inserts it into the editor.
 *
 * @param {any} jsonData - The data object containing the wiki page ID.
 * @param {any} editor - The editor instance where the fetched data will be inserted.
 */
export async function fetchWikiData(jsonData: any, editor: any) {
  const requestOptions = {
    method: 'GET', // Ensure method is GET
    headers: requestHeaders, // Your existing headers
  };

  let url = `${endPoint}/api/wiki/${jsonData?.id}?view=body`;
  if (jsonData?.isAssociatedWithWorkItem) {
    url += `&isAssociatedWithWorkItem=true`;
  }

  const response = await fetch(url, requestOptions);
  if (!response.ok) throw new Error('The document could not be loaded. Please try again.');
  const result = await response.json();
  if (result?.success === false || !result?.data) throw new Error('The document could not be loaded. Please try again.');
  let body = result.data.body ?? result.data.markdown;
  if (typeof body === 'string') {
    // MCP clients can store Markdown directly; browser-authored documents
    // may instead arrive as JSON-encoded BlockNote arrays.
    try {
      const decoded = JSON.parse(body);
      if (Array.isArray(decoded) || typeof decoded === 'string') body = decoded;
    } catch { /* The string itself is document text, not serialized blocks. */ }
    if (typeof body === 'string') body = await parseExtractedMarkdown(editor, body);
  }
  if (body && !Array.isArray(body) && typeof body.markdown === 'string') {
    body = await parseExtractedMarkdown(editor, body.markdown);
  }
  if (body == null) body = [];
  if (!Array.isArray(body)) throw new Error('This document has an unsupported content format.');
  if (body.length === 1 && body[0] && typeof body[0].html === 'string') {
    const content = body[0].html;
    body = /<\/?[a-z][^>]*>/i.test(content)
      ? await editor.tryParseHTMLToBlocks(content)
      : await parseExtractedMarkdown(editor, content);
  }
  // A collaborator may have typed while the HTTP request was in flight.
  // Never replace their content, and use the editor API rather than mutating
  // its cached document array before inserting against a now-missing block.
  if (body.length && isDocumentEmpty(editor)) {
    editor.replaceBlocks(editor.document, body);
  }
}

export function isDocumentEmpty(editor: any): boolean {
  const blocks = editor.document;
  // Collaboration can restore several empty paragraphs, or empty text nodes.
  // Those placeholders must not prevent loading the persisted document body.
  return blocks.every(block => block.type === 'paragraph' &&
    (!block.content?.length || (Array.isArray(block.content) && block.content.every(
      inline => inline.type === 'text' && !inline.text?.trim()
    ))) && !block.children?.length);
}
